import { WIDGET_REFRESH_STORAGE_KEY } from '@wix/wix-chatbot-common/browser';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectIsSessionExpired } from '../../common/selectors/widgetSession';
import { widgetSDK } from '../../sdk/widgetSDK';

const onClickSessionExpired = () => {
  window.sessionStorage.setItem(WIDGET_REFRESH_STORAGE_KEY, 'true');
  widgetSDK.refreshRuntimeData();
  window.location.reload();
};

export const useSessionExpired = () => {
  const [showSessionExpired, setShowSessionExpired] = useState(false);
  const pageRef = useRef<HTMLDivElement | null>(null);
  const isSessionExpired = useSelector(selectIsSessionExpired);

  useEffect(() => {
    if (!isSessionExpired) {
      return;
    }
    const element = pageRef.current;
    setShowSessionExpired(true);

    if (element) {
      element.addEventListener('click', onClickSessionExpired);
    }

    return () => {
      if (element) {
        element.removeEventListener('click', onClickSessionExpired);
      }
    };
  }, [isSessionExpired]);

  return { showSessionExpired, setShowSessionExpired, pageRef };
};
